import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';
import { jobOffer } from 'job/model/job-offer.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { tasksParticipant } from '../model/task.fragments';
import { TaskOutput } from '../model/task.output';

export interface CreateContactMeetingInput {
	readonly contactId: string;
	readonly dueTimestamp: number;
}

export interface CreateContactMeetingParams {
	input: CreateContactMeetingInput;
}

@Injectable({ providedIn: 'root' })
export class CreateContactMeetingApiMutation extends ApiMutation<
	TaskOutput,
	CreateContactMeetingParams
> {
	client = 'iam';
	document = gql`
		mutation CreateContactMeeting($input: CreateContactMeetingInput!) {
			createContactMeeting(input: $input) {
				id
				done
				type
				owner {
					id
				}
				contact {
					...Contact
				}
				jobOffer {
					...JobOffer
				}
				modulesId
				todoTitle
				dueTimestamp
				updateTimestamp
				participants {
					...TasksParticipant
				}
				todoDescription
			}
		}
		${tasksParticipant}
		${jobOffer}
		${contact}
	`;
	method = 'createContactMeeting';
}
